import { createAsyncThunk } from '@reduxjs/toolkit';

import type { ITeacher } from '@/Module/Teacher/Model/DataModel';
import { TeacherService } from '@/Module/Teacher/Service';

export const getTeacherByIdAction = createAsyncThunk<ITeacher, ITeacher['id']>(
  'teacher/getTeacherById',
  async (teacherId, { signal }) => {
    return TeacherService.getById(teacherId, signal).then(({ data: { data } }) => data);
  },
);
